import { render, staticRenderFns } from "./PagamentosDashUfi.vue?vue&type=template&id=1f029390"
import script from "./PagamentosDashUfi.vue?vue&type=script&lang=js"
export * from "./PagamentosDashUfi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports